var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path === '/user/add') ? [_c('UserForm')] : _vm._e(), _vm._v(" "), (_vm.$route.path === '/user/parents') ? [_c('ParentFormContainer', {
    attrs: {
      "forClient": true
    }
  })] : _vm._e(), _vm._v(" "), (_vm.$route.path === '/user/payment') ? [_c('PaymentForm', {
    attrs: {
      "forClient": true,
      "activeSub": _vm.activeSub,
      "groupRedirect": !!_vm.activeGroup
    }
  })] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c86af9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AddUser/AddUser.vue
// module id = NYeJ
// module chunks = 2